<template>
    <div class="card-go-to-block big-card-block block-card card-border ">
        <v-expansion-panel expand :value="panel">
            <v-expansion-panel-content :lazy="true">
                <template v-slot:header >
                    <div class="block-card-title handle" >
                        <div class="title-icon">
                            <img src="../../../../assets/img/ic_go_to_block_round.png" alt="">
                        </div>

                        <h4>If Else Go To</h4>
                    </div>
                </template>
                <div class="block-card-body">
                    <p>
                        Lets you redirect users to random or specific block depending on User Attributes when entering a block with this plugin.</p>
                    <div class="go-to">
                        <div
                            class="card-go-to-item nested-card"
                            v-for="(item, index) in data.cards"
                        >
                            <filters :filters="item.filter" ></filters>
                            <v-layout row class="mt-5 mb-3" justify-end>
                                <v-flex xs6>
                                    <p>Redirect To Block</p>
                                </v-flex>
                                <v-flex xs6 class="text-xs-right">
                                    <v-switch
                                            v-model="item.random"
                                            label="Random"
                                            class="pull-right"
                                    ></v-switch>
                                </v-flex>
                            </v-layout>
                            <block-redirect
                                    :blocks="item.blocks"
                                    :block-list="blocksList"
                                    :random="item.random"
                            >
                            </block-redirect>
                            <v-btn
                                    @click="deleteCard(index)"
                                    v-if="index>0"
                                    fab small color=""
                                    class="delete-go-to-card delete-button"
                            ><v-icon small color="#666">delete_outline</v-icon></v-btn>
                        </div>
                        <div class="text-xs-center">
                            <v-btn
                                    large round flat
                                    class="primary--text x-large-button"
                                    @click="addCard"
                            >
                                <v-icon>add_circle_outline</v-icon>
                                Add Else
                            </v-btn>
                        </div>
                    </div>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </div>
</template>

<script>
    import common from "../../../../utils/common"
    import filters from './common-inner-blocks/filters'
    import blockRedirect from './common-inner-blocks/block-redirect'
    export default {
        name: "card-image-url",
        components: {
            filters,
            blockRedirect
        },
        props: {
            data: {
                type: Object,
                default: ()=> {
                    return {}
                }
            },
            index: {
                type: Number,
                default: ()=> {
                    return 0
                }
            },
            blocksList: {
                type: Array,
                default: ()=> {
                    return []
                }
            }
        },
        data() {
            return {
                valid: true,
                panel: 1,
                common
            }
        },
        mounted() {

        },
        methods: {
            addCard() {
                this.data.cards.push({
                    filter:[
                        {
                            attribute:'',
                            operator:'is',
                            value:'',
                            condition:'or'
                        }
                    ],
                    blocks:[{
                        blocks:[]
                    }],
                    random:false
                })
            },
            deleteCard(index) {
                this.data.cards.splice(index, 1)
            }
        },
        computed: {
            variables() {
                return this.$store.state.blocksBuild.variables
            }
        },
        watch: {

        }
    }
</script>

<style scoped>

</style>